import React, {useState, useEffect, useRef} from 'react';
import BannerNomina from '../TTNomina/BannerNomina';
import DescripcionNomina from '../TTNomina/DescripcionNomina';
import FichaTecnicaNomina from '../TTNomina/FichaTecnicaNomina';
import DescripcionNominaFondo from '../TTNomina/DescripcionNominaFondo';

export default function TTNOMINA(props){

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);


    return(<>
    <BannerNomina/>
    <DescripcionNomina/>
    <FichaTecnicaNomina/>
    <DescripcionNominaFondo/>
    </>)
}